import { render, staticRenderFns } from "./resultsDisplay.vue?vue&type=template&id=20e91682"
import script from "./resultsDisplay.vue?vue&type=script&lang=js"
export * from "./resultsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports